import { axiosInstance } from 'src/store/server/client';
import type { APICommonResponse } from 'src/types/common.types';
import utils from 'src/utils/utils';

import type {
  GetApplyHistoryDetailRequest,
  GetApplyHistoryDetailResponse,
  GetApplyHistoryRequest,
  GetApplyHistoryResponse,
  GetApplyNoInfoCountResponse,
  GetDailyAttendanceStatusResponse,
  GetMyPointResponse,
  GetPointHistoryRequest,
  GetPointHistoryResponse,
  PostDailyAttendanceResponse,
  UpdateApplyInfoRequest,
  UpdateApplyInfoResponse,
} from './point.dto';

export const pointService = {
  // 보유 코튼(포인트) 조회
  getMyPoint: async (): Promise<APICommonResponse<GetMyPointResponse>> => {
    return axiosInstance.market.private.get('/point/my');
  },

  // 코튼(포인트) 히스토리 조회
  getPointHistory: async ({
    page_num,
    page_size,
    type,
  }: GetPointHistoryRequest): Promise<APICommonResponse<GetPointHistoryResponse>> => {
    return axiosInstance.market.private.get('/point/hist', {
      params: { page_num, page_size, type },
    });
  },

  // 응모자 정보 미입력 조회
  getApplyNoInfoCount: async (): Promise<APICommonResponse<GetApplyNoInfoCountResponse>> => {
    return axiosInstance.market.private.get('/point/apply');
  },

  // 응모내역 조회
  getApplyHistory: async ({
    page_num,
    page_size,
  }: GetApplyHistoryRequest): Promise<APICommonResponse<GetApplyHistoryResponse>> => {
    return axiosInstance.market.private.get('/point/apply/hist', {
      params: { page_num, page_size },
    });
  },

  // 응모내역 상세 조회
  getApplyHistoryDetail: async ({
    hist_idx,
  }: GetApplyHistoryDetailRequest): Promise<APICommonResponse<GetApplyHistoryDetailResponse>> => {
    return axiosInstance.market.private.get(`/point/apply/hist/${hist_idx}`);
  },

  // 포인트 응모 정보 입력 (Update)
  updateApplyInfo: async (data: UpdateApplyInfoRequest): Promise<APICommonResponse<UpdateApplyInfoResponse>> => {
    const { hist_idx, ...rest } = data;
    const formData = utils.jsonToFormData(rest);

    return axiosInstance.market.private.put(`/point/apply/hist/${hist_idx}`, formData, {
      headers: {
        contextType: 'multipart/form-data',
      },
    });
  },

  // 데일리 코튼(포인트) 참여 여부 조회
  getDailyAttendanceStatus: async (): Promise<APICommonResponse<GetDailyAttendanceStatusResponse>> => {
    return axiosInstance.market.private.get('/point/main/attendance');
  },

  // 데일리 코튼(포인트) 참여
  postDailyAttendance: async (): Promise<APICommonResponse<PostDailyAttendanceResponse>> => {
    return axiosInstance.market.private.post('/point/main/attendance', {});
  },
};
